import VirtualCreditCardDetail from '@/views/VirtualCreditCardDetail/index.vue'

const VirtualCreditCardDetailRouter = {
  path: '/virtual-credit-card-details',
  name: 'VirtualCreditCardDetail',
  component: VirtualCreditCardDetail,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default VirtualCreditCardDetailRouter
